export const FETCH_TRANSLATORS_REQUEST = 'FETCH_TRANSLATORS_REQUEST';
export const FETCH_TRANSLATORS_SUCCESS = 'FETCH_TRANSLATORS_SUCCESS';
export const FETCH_TRANSLATORS_FAILURE = 'FETCH_TRANSLATORS_FAILURE';
